import { t } from 'i18next';
import React from 'react';
import AdvancedLazyImage from "./AdvancedLazyImage";
const Store = () => {
  const storeItems = [
    {
      id: 1,
      name: t('fertilizers'),
      image: "img/Products/seeds-1.png",
      description: t('fertilizers_description')
    },
    {
      id: 2,
      name: t('seeds_alfa'),
      image: "img/Products/seeds-2.png",
      description: t('seeds_description')
    },

  ];

  return (
    <div className="container-xxl py-5 video">
      <div className="container">
        <div className="section-title text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '750px' }}>
          <h1 className="display-6 text-white">{t('bountiful_land')}</h1>
        </div>
        <div className="row g-4">
          {storeItems.map(item => (
            <div key={item.id} className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay={`0.${item.id * 2 - 1}s`}>
              <div className="store-item position-relative text-center mb-3">
                <AdvancedLazyImage
                  className="img-fluid"
                  src={item.image}
                  alt={item.name}
                  style={{ height: "100%", objectFit: "cover", width: "350px" }}
                />
                {/* <div className="p-4">
                  <div className="text-center mb-3">
                    {[...Array(5)].map((_, i) => (
                      <small key={i} className="fa fa-star text-primary"></small>
                    ))}
                  </div>
                </div> */}
              </div>
            </div>
          ))}
          <div className="col-12 text-center wow fadeInUp mb-3" data-wow-delay="0.1s">
            {/* <a href="" className="btn btn-primary rounded-pill py-3 px-5">{t('view_more_products')}</a> */}
            <h2 className="mb-3">{storeItems[1].name}</h2>
            <h5>{storeItems[1].description}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Store;
